export default __webpack_public_path__ + "static/media/rehack-18.f57afa32.png";